(async () => {
  if (!customElements.get("product-form")) {
    const { Fancybox } = await import("@fancyapps/ui");
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Select other web components for the methods to use
        this.cartNotification = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer");
        this.quickShop = this.closest("quick-shop");
        this.stickyAddToCart = document.querySelector(
          "[data-sticky-add-to-cart]"
        );
        this.formToggleButton = document.querySelector("[data-form-toggle]");
        this.mainCartItems = document.querySelector("cart-items");

        this.form = this.querySelector("form");

        this.form.addEventListener("submit", (event) => {
          event.preventDefault();

          // Check if the component is inside the quick shop component
          if (this.quickShop) {
            this.quickShop.querySelector("[data-quick-shop-option]:checked")
              ? this.onSubmitHandler()
              : "";
          } else {
            this.onSubmitHandler();
          }
          this.updateProgressBarVisibility();
        });
      }

      updateProgressBarVisibility() {
        // Update visibility free gift progress bar
        let giftCards = document.querySelectorAll(
          '[data-item-type="giftcard"]'
        );
        const progressBar = document.querySelector("progress-bar");
        const freeGift = document.querySelector("free-gift");

        // if there are no gift cards in the cart
        if (giftCards.length === 0) {
          if (progressBar && freeGift) {
            progressBar.classList.remove("hidden");
            freeGift.classList.remove("hidden");
          }
        } else {
          if (progressBar && freeGift) {
            progressBar.classList.add("hidden");
            freeGift.classList.add("hidden");
          }
        }
      }

      updateStickyForm() {
        // toggle form and toggle buttons visibility
        const productForm = document.querySelector("[data-product-variants]");
        const backdrop = document.querySelector("[data-form-backdrop]");
        if (this.formToggleButton) {
          this.formToggleButton.classList.remove("visibility-hidden");
        }
        if (productForm) {
          productForm.classList.add("visibility-hidden");
        }
        if (backdrop) {
          backdrop.classList.add("visibility-hidden");
        }
      }

      updateForm() {
        // toggle form and toggle buttons visibility
        const productForm = document.querySelector("[data-product-variants]");
        const addToCartBtn = document.querySelector("[data-add-to-cart-btn]");

        // uncheck checked variant
        if (productForm) {
          let sizeOptions = productForm.querySelectorAll(
            ".options__input--size"
          );
          for (let i = 0; sizeOptions[i]; ++i) {
            if (sizeOptions[i].checked) {
              sizeOptions[i].checked = false;
              break;
            }
          }

          //update add to cart button
          addToCartBtn.setAttribute("disabled", true);
          if (addToCartBtn.classList.contains("private-sale")) {
            // addToCartBtn.textContent = window.variantStrings.registerOrSignIn;
            addToCartBtn.textContent = window.variantStrings.selectSize;
          } else if (addToCartBtn.classList.contains("is-logged-in")) {
            addToCartBtn.textContent = window.variantStrings.selectSize;
          } else if (addToCartBtn.classList.contains("giftcard")) {
            addToCartBtn.textContent = window.variantStrings.selectGiftcard;
          } else if (addToCartBtn.classList.contains("upsell")) {
            addToCartBtn.textContent = window.variantStrings.upsellAddToCart;
            addToCartBtn.removeAttribute("disabled");
          } else {
            addToCartBtn.textContent = window.variantStrings.selectSize;
          }
        }
      }

      updateMobileForm() {
        // toggle form and toggle buttons visibility
        const mobileVariants = document.querySelector(".product__form-wrapper");

        // uncheck checked mobile variant
        if (mobileVariants) {
          let sizeOptionsMob = mobileVariants.querySelectorAll(
            ".options__input--size"
          );
          for (let i = 0; sizeOptionsMob[i]; ++i) {
            if (sizeOptionsMob[i].checked) {
              sizeOptionsMob[i].checked = false;
              break;
            }
          }
        }
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      updateCartIconBubble(parsedState) {
        const cartIconBubble = document.querySelector("cart-icon-bubble");

        if (cartIconBubble) {
          const cartIconBubbleSection = {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: "[data-cart-icon-bubble]",
          };

          const selector = document.querySelector(
            cartIconBubbleSection.selector
          );

          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[cartIconBubbleSection.section],
              cartIconBubbleSection.selector
            );
          }
        }
      }

      onSubmitHandler() {
        const submitButton = this.querySelector('[type="submit"]');
        const timeout = submitButton.dataset.closeTimeout;
        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        document.querySelector("cart-icon-bubble").classList.add("is-loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        let sectionsToFetch = "";
        // Get section to fetch
        if (this.cartDrawer) {
          sectionsToFetch = [
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
            ...this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        } else {
          sectionsToFetch = [
            ...this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        const formData = new FormData(this.form);
        formData.append("sections", sectionsToFetch);
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        const MixedCart = document.querySelector(".mixed-cart");

        if (MixedCart) {
          // Does the cart drawer contain a gift card
          let cartHasGiftcard = document.querySelector(
            '[data-item-type="giftcard"]'
          )
            ? true
            : false;
          // Is the new added item a product
          let newProduct =
            this.form.querySelector('input[name="product_type"]').value ===
            "product"
              ? true
              : false;

          // Does the cart drawer contain a product
          let cartHasProducts = document.querySelector(
            '[data-item-type="product"]'
          )
            ? true
            : false;
          // Is the new added item a giftcard
          let newGiftCard =
            this.form.querySelector('input[name="product_type"]').value ===
            "giftcard"
              ? true
              : false;

          // if cart had giftcard and added item is product or if cart has product(s) and added item is gift card, open the popup and disable all loading elements.
          if (
            (cartHasGiftcard && newProduct) ||
            (cartHasProducts && newGiftCard)
          ) {
            if (cartHasGiftcard && newProduct) {
              MixedCart.renderMixedCartPopup("product");
            } else {
              MixedCart.renderMixedCartPopup("giftcard");
            }
            //buttonClose.addEventListener('click', this.closeMixedCartPopup());
            this.mainCartItems.disableLoading();
            this.updateStickyForm();
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            return;
          }
        }

        return new Promise((resolve, reject) => {
          try {
            (async () => {
              let response = await fetch(`${routes.cart_add_url}`, config);
              let parsedState = await response.json();

              // Store the original parsedState (main product) for notification
              const originalParsedState = { ...parsedState };

              // Check for free product metafield from the hidden input field
              let freeProductValue = formData.get("free_product_id");

              // First check if we have a direct variant ID provided
              const freeProductVariantId = formData.get(
                "free_product_variant_id"
              );

              // Only process if we have a valid value
              if (
                (!freeProductValue && !freeProductVariantId) ||
                freeProductValue === "null" ||
                freeProductValue === ""
              ) {
                // No valid free product value found in form data
              } else {
                try {
                  // Get the variant ID using the most reliable method first
                  let variantId = null;

                  // 1. Direct variant ID from form data - most reliable method
                  if (freeProductVariantId) {
                    variantId = parseInt(freeProductVariantId, 10);
                  }

                  // 2. Check data attributes on form elements
                  if (!variantId) {
                    // Query all possible elements that might contain the variant ID
                    const possibleElements = [
                      this.form.querySelector("[name='free_product_id']"),
                      this.form,
                      this.form.querySelector("[data-free-product-variant]"),
                      document.querySelector("[data-free-product-variant]"),
                    ];

                    // Find first valid variant ID from data attributes
                    for (const element of possibleElements) {
                      if (element?.dataset?.freeProductVariant) {
                        variantId = parseInt(
                          element.dataset.freeProductVariant,
                          10
                        );
                        break;
                      }
                    }
                  }

                  // 3. Try to parse the value as JSON
                  if (!variantId && freeProductValue) {
                    try {
                      const freeProductData =
                        typeof freeProductValue === "object"
                          ? freeProductValue
                          : JSON.parse(freeProductValue);

                      if (freeProductData?.variants?.length > 0) {
                        // Get first available variant or fallback to first variant
                        const availableVariant = freeProductData.variants.find(
                          (v) => v.available
                        );
                        variantId = (
                          availableVariant || freeProductData.variants[0]
                        ).id;
                      } else if (freeProductData?.id) {
                        variantId = freeProductData.id;
                      }
                    } catch (jsonError) {
                      // Not valid JSON, continue to next method
                    }
                  }

                  // 4. Extract product ID from GID format and fetch product data
                  if (!variantId && typeof freeProductValue === "string") {
                    const match = freeProductValue.match(
                      /gid:\/\/shopify\/Product\/(\d+)/
                    );
                    if (match?.[1]) {
                      const productId = match[1];

                      try {
                        const shopUrl = window.location.origin;
                        const productResponse = await fetch(
                          `${shopUrl}/products/${productId}.js`
                        );

                        if (productResponse.ok) {
                          const productData = await productResponse.json();
                          if (productData.variants?.length > 0) {
                            const availableVariant = productData.variants.find(
                              (v) => v.available
                            );
                            variantId = availableVariant
                              ? availableVariant.id
                              : productData.variants[0].id;
                          }
                        }
                      } catch (fetchError) {
                        console.error(
                          "Error fetching product data:",
                          fetchError
                        );
                      }
                    }
                  }

                  // If we found a variant ID, add the free product to cart
                  if (!variantId) {
                    return;
                  }

                  // Add the free product to cart
                  const mainProductQuantity =
                    parseInt(formData.get("quantity"), 10) || 1;
                  const mainProductVariantId = formData.get("id");

                  // First check if this free product already exists in the cart
                  try {
                    // Get current cart data
                    const cartResponse = await fetch(`${routes.cart_url}.js`);
                    const cartData = await cartResponse.json();

                    // Look for free products with the same variant ID
                    const existingFreeProducts = cartData.items.filter(
                      (item) =>
                        item.variant_id === parseInt(variantId) &&
                        item.properties &&
                        item.properties._free_product === "true"
                    );

                    if (existingFreeProducts.length > 0) {
                      // Get the first matching free product
                      const existingFreeProduct = existingFreeProducts[0];
                      const lineItemPosition =
                        cartData.items.indexOf(existingFreeProduct) + 1;

                      // Calculate the new quantity (current + main product quantity)
                      const newQuantity =
                        existingFreeProduct.quantity + mainProductQuantity;

                      // Update the quantity of the existing free product
                      const updateConfig = fetchConfig("json");

                      // Get cart drawer sections if available
                      const cartDrawerSections = this.cartDrawer
                        ? this.cartDrawer
                            .getSectionsToRender()
                            .map((section) => section.section)
                        : [];

                      // Include all needed sections
                      const allSections = [
                        ...sectionsToFetch,
                        ...cartDrawerSections,
                        "cart-drawer",
                      ];
                      // Remove duplicates
                      const uniqueSections = [...new Set(allSections)];

                      updateConfig.body = JSON.stringify({
                        line: lineItemPosition,
                        quantity: newQuantity,
                        properties: {
                          _free_product: "true",
                          _main_product_variant: mainProductVariantId,
                          _parent_id: mainProductVariantId,
                        },
                        sections: uniqueSections,
                        sections_url: window.location.pathname,
                      });

                      const updateResponse = await fetch(
                        `${routes.cart_change_url}`,
                        updateConfig
                      );
                      const updateResult = await updateResponse.json();

                      if (updateResult) {
                        parsedState = updateResult;
                      }
                    } else {
                      // No existing free product found, add a new one as normal
                      const freeProductFormData = new FormData();
                      freeProductFormData.append("id", variantId);
                      freeProductFormData.append(
                        "quantity",
                        mainProductQuantity
                      );
                      freeProductFormData.append("sections", sectionsToFetch);
                      freeProductFormData.append(
                        "sections_url",
                        window.location.pathname
                      );
                      freeProductFormData.append(
                        "properties[_free_product]",
                        "true"
                      );
                      freeProductFormData.append(
                        "properties[_main_product_variant]",
                        mainProductVariantId
                      );
                      // Also add the parent_id property for better compatibility
                      freeProductFormData.append(
                        "properties[_parent_id]",
                        mainProductVariantId
                      );

                      const freeProductConfig = fetchConfig("javascript");
                      freeProductConfig.headers["X-Requested-With"] =
                        "XMLHttpRequest";
                      delete freeProductConfig.headers["Content-Type"];
                      freeProductConfig.body = freeProductFormData;

                      try {
                        const freeProductResponse = await fetch(
                          routes.cart_add_url,
                          freeProductConfig
                        );
                        const freeProductResult =
                          await freeProductResponse.json();

                        if (
                          !freeProductResult.status ||
                          freeProductResult.status !== "bad_request"
                        ) {
                          parsedState = freeProductResult;
                        } else {
                          console.error(
                            "Error adding free product to cart:",
                            freeProductResult
                          );
                        }
                      } catch (cartError) {
                        console.error(
                          "Error during cart add request:",
                          cartError
                        );
                      }
                    }
                  } catch (cartCheckError) {
                    console.error(
                      "Error checking cart for existing free products:",
                      cartCheckError
                    );
                    // Continue with adding a new free product if we couldn't check the cart

                    const freeProductFormData = new FormData();
                    freeProductFormData.append("id", variantId);
                    freeProductFormData.append("quantity", mainProductQuantity);
                    freeProductFormData.append("sections", sectionsToFetch);
                    freeProductFormData.append(
                      "sections_url",
                      window.location.pathname
                    );
                    freeProductFormData.append(
                      "properties[_free_product]",
                      "true"
                    );
                    freeProductFormData.append(
                      "properties[_main_product_variant]",
                      mainProductVariantId
                    );
                    // Also add the parent_id property for better compatibility
                    freeProductFormData.append(
                      "properties[_parent_id]",
                      mainProductVariantId
                    );

                    const freeProductConfig = fetchConfig("javascript");
                    freeProductConfig.headers["X-Requested-With"] =
                      "XMLHttpRequest";
                    delete freeProductConfig.headers["Content-Type"];
                    freeProductConfig.body = freeProductFormData;

                    try {
                      const freeProductResponse = await fetch(
                        routes.cart_add_url,
                        freeProductConfig
                      );
                      const freeProductResult =
                        await freeProductResponse.json();

                      if (
                        !freeProductResult.status ||
                        freeProductResult.status !== "bad_request"
                      ) {
                        parsedState = freeProductResult;
                      } else {
                        console.error(
                          "Error adding free product to cart:",
                          freeProductResult
                        );
                      }
                    } catch (cartError) {
                      console.error(
                        "Error during cart add request:",
                        cartError
                      );
                    }
                  }
                } catch (error) {
                  console.error("Error processing free product:", error);
                }
              }

              let cartResponse = await fetch(`${routes.cart_url}`, config);
              let parsedStateCart = await cartResponse.json();

              // Update drawer once with final state
              if (this.cartDrawer) {
                try {
                  // Ensure we have the cart-drawer section in parsedState
                  if (
                    !parsedState.sections ||
                    !parsedState.sections["cart-drawer"]
                  ) {
                    // Fetch the latest cart data with sections
                    const drawerSections = this.cartDrawer
                      .getSectionsToRender()
                      .map((section) => section.section);
                    const cartDrawerResponse = await fetch(
                      `${
                        window.location.pathname
                      }?sections=${drawerSections.join(",")}`
                    );
                    const cartDrawerSections = await cartDrawerResponse.json();

                    // Add the drawer sections to parsedState
                    if (!parsedState.sections) {
                      parsedState.sections = {};
                    }

                    // Copy sections to parsedState
                    Object.keys(cartDrawerSections).forEach((section) => {
                      parsedState.sections[section] =
                        cartDrawerSections[section];
                    });
                  }

                  this.cartDrawer.renderContents(parsedState);
                } catch (renderError) {
                  console.error("Error rendering cart drawer:", renderError);
                  // Try to re-render with the latest cart state as fallback
                  try {
                    this.cartDrawer.renderContents(parsedStateCart);
                  } catch (fallbackError) {
                    console.error(
                      "Fallback rendering also failed:",
                      fallbackError
                    );
                  }
                }
              }

              // Get cart sections
              let sections = [
                ...this.mainCartItems
                  .getSectionsToRender()
                  .map((section) => section.section),
              ];
              // Remove duplicates
              sections = sections.filter((item, index) => {
                return sections.indexOf(item) === index;
              });

              let cartSectionsResponse = await fetch(
                `${window.location.pathname}?sections=${sections.join(",")}`
              );
              let cartSections = await cartSectionsResponse.json();

              // Add the cart sections to the parsedState
              sections.map((section) => {
                parsedState.sections[section] = cartSections[section];
              });

              // Update cart page
              this.mainCartItems.renderContents(parsedState);
              this.mainCartItems.updateContents(parsedState);

              // Update cart icon bubble after all other updates are complete
              setTimeout(() => {
                this.updateCartIconBubble(parsedState);
              }, 100);

              let addToCartBehavior = submitButton.dataset.addToCartBehavior;
              if (window.screen.width < 768) {
                addToCartBehavior = "show_cart_notification";
              }

              if (!this.cartDrawer) {
                addToCartBehavior = "show_cart_notification";
              }

              // Add to cart behavior
              switch (addToCartBehavior) {
                case "open_cart_drawer":
                  this.cartDrawer.open();
                  setTimeout(() => {
                    this.cartDrawer.close();
                  }, timeout);
                  break;
                case "show_cart_notification":
                default:
                  this.cartNotification.setActiveElement(
                    document.activeElement
                  );
                  // Use original product state for cart notification
                  if (originalParsedState) {
                    this.cartNotification.renderContents(originalParsedState);
                  } else {
                    this.cartNotification.renderContents(parsedState);
                  }
              }

              // Update free gift
              const freeGift = document.querySelector("free-gift");
              freeGift?.update(parsedStateCart);

              // Update progress bar
              const progressBar = document.querySelector("progress-bar");
              progressBar?.update(parsedStateCart);

              // Close quickshop after add to cart
              if (this.quickShop) {
                this.quickShop.onPopupToggle();
              }

              // Remove loading state
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
              setTimeout(() => {
                document
                  .querySelector("cart-icon-bubble")
                  .classList.remove("is-loading");
              }, 500);

              resolve();

              if (this.stickyAddToCart) {
                this.updateStickyForm();
                this.updateForm();
                this.updateMobileForm();
              }
            })();
          } catch (error) {
            reject();
          }
        });
      }
    }

    window.ProductForm = ProductForm;
    customElements.define("product-form", ProductForm);
  }
})();
